export default __webpack_public_path__ + "static/solution-maintenance.url-3f3862017344fdab9fe3578c29962346.svg";